import { BaseERC20 } from '@arcxgame/contracts/dist/src/typings/BaseERC20'
import { BaseERC20Factory } from '@arcxgame/contracts/dist/src/typings/BaseERC20Factory'
import { poll } from '@arcxmoney/arcx-react'
import { constants, Signer } from 'ethers'
import { useEffect, useMemo, useState } from 'react'

export function useErc20Balance(erc20address: string, signer: Signer, account?: string) {
  const [balance, setBalance] = useState(constants.Zero)

  const erc20Contract = useMemo<BaseERC20>(() => {
    if (!signer || !erc20address) {
      return { balanceOf: () => constants.Zero } as unknown as BaseERC20
    }
    return BaseERC20Factory.connect(erc20address, signer)
  }, [erc20address, signer])

  useEffect(() => {
    if (!signer) {
      return
    }
    return poll(async () => {
      try {
        if (!signer || !erc20address) {
          return
        }

        const balance = await getErc20Balance(erc20Contract, signer, account)
        setBalance((prev) => (prev.eq(balance) ? prev : balance))
      } catch (err) {
        console.error(`Error setting balance of token ${erc20address}: ${err}`)
      }
    }, 5000)
  }, [erc20Contract, signer, account, erc20address])

  return balance
}

export async function getErc20Balance(erc20: BaseERC20, signer: Signer, account: string) {
  return erc20.balanceOf(account || (await signer.getAddress()))
}
